const FEATURE_HELP_URLS = {
  agent_bots: 'https://devnx.com.br/hc/agent-bots',
  agents: 'https://devnx.com.br/hc/agents',
  audit_logs: 'https://devnx.com.br/hc/audit-logs',
  campaigns: 'https://devnx.com.br/hc/campaigns',
  canned_responses: 'https://devnx.com.br/hc/canned',
  channel_email: 'https://devnx.com.br/hc/email',
  channel_facebook: 'https://devnx.com.br/hc/fb',
  custom_attributes: 'https://devnx.com.br/hc/custom-attributes',
  dashboard_apps: 'https://devnx.com.br/hc/dashboard-apps',
  help_center: 'https://devnx.com.br/hc/help-center',
  inboxes: 'https://devnx.com.br/hc/inboxes',
  integrations: 'https://devnx.com.br/hc/integrations',
  labels: 'https://devnx.com.br/hc/labels',
  macros: 'https://devnx.com.br/hc/macros',
  message_reply_to: 'https://devnx.com.br/hc/reply-to',
  reports: 'https://devnx.com.br/hc/reports',
  sla: 'https://devnx.com.br/hc/sla',
  team_management: 'https://devnx.com.br/hc/teams',
  webhook: 'https://devnx.com.br/hc/webhooks',
  billing: 'https://devnx.com.br/pricing',
  saml: 'https://devnx.com.br/hc/saml',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
